<template>
  <!-- 需要软件升级弹窗 -->
  <div :class="[classType == 1 ? 'top_des' : 'top_des1']">
    <span class="top_des_title" v-if="name">{{ name }}</span>
    <el-button class="top_button" v-zoom='{from:pageName,name:button1}' @click="resetForm('myEvent',true)"  v-if="button1">{{
      button1
    }}</el-button>
    <el-button class="top_button" v-zoom='{from:pageName,name:button2}' @click="resetFormCommodity" v-if="button2">{{
      button2
    }}</el-button>
    <el-button class="top_button" v-zoom='{from:pageName,name:button3}' @click="resetFormShop" v-if="button3">{{
      button3
    }}</el-button>
    <span class="top_des_text" v-if="desc">
      <img
        src="@/assets/images/new_icon_waring_yellow.png"
        style="
          display: inline-block;
          float: left;
          width: 14px;
          height: 14px;
          color: #ffffff;
          margin: 6px 4px 0px 0px;
        "
      />
      {{ desc }}
      <span class="to_set" @click="toSet" v-if="showSet">去设置</span>
    </span>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  name: "top-title",
  components: {},
  props: {
    classType: null,
    pageName:{
      type:String,
      default:"忠诚度管理-优惠券管理"
    },
    name: {
      type: String,
      default: "",
    },
    button1: {
      type: String,
      default: "",
    },
    button2: {
      type: String,
      default: "",
    },
    button3: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    },
    showSet: {
      type: Boolean,
      default: false,
    }, // 显示去设置
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
  },
  beforeCreate() {},
  beforeMount() {},
  created() {},
  mounted() {},
  methods: {
    toSet() {
      let routeUrl = this.$router.resolve({
        path: "/backstage",
        query: { to: "/backstage/smsmanage/charge" },
      });
      window.open(routeUrl.href, "_blank");
    },
    resetFormShop() {
      window.open("https://prom.shop.jd.com/web/coupon/detail/shop/0");
    },
    resetFormCommodity() {
      window.open("https://prom.shop.jd.com/web/coupon/detail/goods/0");
    },
    resetForm() {
      this.$emit("myEvent");
    },
  },
};
</script>

<style lang="scss" scoped>
.top_des {
  padding: 13px 0;
  min-width: 1020px;
  border-bottom: 1px solid rgba(246, 246, 246, 1);
  // background: #fff;
}
.top_des1 {
  padding: 20px 0;
  background: #fff;
  border-radius: 6px;
  margin: 10px 0 20px 0;
  border-bottom: 1px solid #f0f0f0;
  // box-shadow:0px 4px 8px rgba(0,0,0,0.1);
}
.top_des_title {
  font-size: 16px;
  // font-family: PingFang SC;
  font-weight: bold;
  line-height: 28px;
  color: #2e3458;
  opacity: 1;
  margin: 0 12px 0 30px;
}
.top_des_text {
  height: 28px;
  background: #FFFAEE;
  opacity: 1;
  border-radius: 14px;
  line-height: 26px;
  display: inline-block;
  padding: 0 12px;
  vertical-align: top;
  font-size: 14px;
  // font-family: PingFang SC;
  font-weight: 350;
  color: rgba(51, 51, 51, 1);
}
.top_button {
  float: right;
  width: 120px;
  margin-right: 10px;
}
.to_set {
  height: 18px;
  font-size: 14px;
  /* font-family: PingFang SC; */
  font-weight: 400;
  line-height: 21px;
  color: rgba(254, 77, 69, 1);
  opacity: 1;
  margin-left: 10px;
  cursor: pointer;
}
</style>
